import styled from "styled-components"

const Wrapper = styled.div.attrs({
    className: 'app-wrapper'
})``

Wrapper.displayName = 'Wrapper'

export default Wrapper